import React from 'react';
import { ClipLoader } from 'react-spinners';
import Paragraph from 'shared/components/Paragraph';
import './styles/OverlayLoading.scss';

export default ({ loading, text }) => {
  return loading ? (
    <div className='c-overlayloading'>
      <ClipLoader size={24} color='#0066B3' />
      <Paragraph size='medium'>{text}</Paragraph>
    </div>
  ) : null;
};
